import { FC, MouseEvent, FormEvent } from 'react';
import { CircularProgress } from '@mui/material';
import { AddOrderPaymentDialogProps } from '../../../models/DialogBox.interface';
import {
  StyledDialog,
  RelativePositionBox,
  CloseIcon,
  FormContentBox,
  ScrollableFormContent,
  ButtonContainer,
  CancelButton,
  BorderedSectionBox,
  SectionTitleTypography,
  HeaderBoxSimple,
  TitleTypographyLarge,
  SubtitleTypographySimple,
  SubmitButton,
  FormContainer,
  StyledCircularProgress,
} from './OrderPaymentDialog.styles';

const AddOrderPaymentDialog: FC<AddOrderPaymentDialogProps> = ({
  open,
  handleClose,
  title,
  subtitle,
  children,
  onSubmit,
  buttonLabel = 'Save',
  buttonDisabled,
  onSaveClick,
  paymentModeSection,
}) => {
  const handleSave = (e: MouseEvent) => {
    e.preventDefault();
    onSaveClick?.();
  };

  return (
    <StyledDialog open={open} onClose={handleClose}>
      <RelativePositionBox>
        <CloseIcon
          component="i"
          className="bx bx-x-circle"
          onClick={handleClose}
        />
      </RelativePositionBox>
      <HeaderBoxSimple>
        <TitleTypographyLarge>{title}</TitleTypographyLarge>
        <SubtitleTypographySimple>{subtitle}</SubtitleTypographySimple>
      </HeaderBoxSimple>
      <FormContainer onSubmit={onSubmit}>
        <ScrollableFormContent>
          <FormContentBox>{children}</FormContentBox>
          {paymentModeSection && (
            <BorderedSectionBox>
              <SectionTitleTypography>Payment Method</SectionTitleTypography>
              {paymentModeSection}
            </BorderedSectionBox>
          )}
          <ButtonContainer>
            <SubmitButton
              type="button"
              disabled={buttonDisabled}
              onClick={handleSave}
            >
              {buttonDisabled ? (
                <StyledCircularProgress>
                  <CircularProgress size={20} />
                </StyledCircularProgress>
              ) : (
                buttonLabel
              )}
            </SubmitButton>
            <CancelButton type="button" onClick={handleClose}>
              Cancel
            </CancelButton>
          </ButtonContainer>
        </ScrollableFormContent>
      </FormContainer>
    </StyledDialog>
  );
};

export default AddOrderPaymentDialog;
